import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { useSnackbar } from 'notistack';
import '../../App.css';
import { Button, Checkbox, Grid, FormControl, Box } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import GetAppIcon from '@material-ui/icons/GetApp';
import DeleteIcon from '@material-ui/icons/Delete';
import { checkResData } from '../../utils/common';
import { progressFlgState, btnColor } from '../../GlobalState';
import {
  getPictureDownload,
  getPicturesZip,
  deletePicture
} from '../../apicalls/cloud/sharePicture';
import {
  TSharedPictureList,
  TSharedPicture
} from '../../types/cloudStorage/CloudFileList';
import { AddModal } from '../pictureListPage/AddModal';
import { DeleteModal } from './DeleteModal';
import { PictureList } from './PictureList';
import { getThumbnail } from '../../apicalls/cloud/sharePicture';
import _ from 'lodash';
import { CustomTooltip } from '../tooltip/CustomTooltip';
import { BasicSelect } from '../parts/input/BasicSelect';
import PaginationComponent from '../../components/PaginationComponent';
import { on } from 'events';

type Tprops = {
  sharedPictureList: TSharedPictureList;
  getSharedPictureList: () => void;
};

//写真一覧用フォルダリスト
export const FolderField: React.FC<Tprops> = (props: Tprops) => {
  const history: any = useHistory();
  const classes = useStyles();
  const { sharedPictureList, getSharedPictureList } = props;
  const [pictData, setPictData] =
    useState<TSharedPictureList>(sharedPictureList);

  const { enqueueSnackbar } = useSnackbar();

  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);
  const [buttonColor] = useRecoilState(btnColor);

  // 写真追加モーダル開閉用
  const [addModalopen, setAddModalOpen] = useState<boolean>(false);
  // 写真削除モーダル開閉用
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);

  const [selectedPictures, setSelectedPictures] = useState<TSharedPicture[]>(
    []
  );

  // フォルダ内の写真を全チェック
  const [allChecked, setAllChecked] = useState<boolean>(false);
  // 共有先がアップロードした写真を全チェック
  const [allUploadedPicturesChecked, setAllUploadedPicturesChecked] =
    useState<boolean>(false);
  // 共有先がアップロードした写真があるか判定
  const isUploadedPicture = sharedPictureList.pictures.some(
    picture =>
      picture.created_guest_id === sharedPictureList.share_picture_guest_id
  );

  const [disableDownloadBtn, setDisableDownloadBtn] = useState<boolean>(true);
  useEffect(() => {
    if (selectedPictures.length === 0) {
      setDisableDownloadBtn(true);
    } else {
      setDisableDownloadBtn(false);
    }
  }, [selectedPictures]);

  const [disableDeleteBtn, setDisableDeleteBtn] = useState<boolean>(true);
  useEffect(() => {
    if (
      selectedPictures.length > 0 &&
      selectedPictures.every(picture => picture.created_guest_id !== null)
    ) {
      setDisableDeleteBtn(false);
    } else {
      setDisableDeleteBtn(true);
    }
  }, [selectedPictures]);

  useEffect(() => {
    (async () => {
      await getDispThumbnail();
    })();
  }, [sharedPictureList.pictures.length]);

  // ページネーション
  const [displayLimit, setDisplayLimit] = useState<number>(30);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(
    history.location.state?.currentPage || 1
  );

  const paginatedPictures = pictData.pictures.slice(
    (currentPage - 1) * displayLimit,
    currentPage * displayLimit
  );

  useEffect(() => {
    setPageCount(Math.ceil(pictData.pictures.length / displayLimit));
  }, [pictData, displayLimit]);

  useEffect(() => {
    setCurrentPage(1);
  }, [displayLimit]);

  /**
   * サムネイル取得
   */
  const getDispThumbnail = async () => {
    const upCount =
      sharedPictureList.pictures.length - pictData.pictures.length;

    if (upCount >= 0) {
      for (let i = 0; i < sharedPictureList.pictures.length; i++) {
        let index = pictData.pictures.findIndex(
          u => u.id === sharedPictureList.pictures[i].id
        );
        if (index == -1 || !pictData.pictures[index].src) {
          await getThumbnail(sharedPictureList.pictures[i].id).then(data => {
            if (data.data) {
              const image_data = data.data.replace(/^.*,/, '');
              setPictData((preSetting: TSharedPictureList) => {
                const newPreSetting: TSharedPictureList =
                  _.cloneDeep(preSetting);
                if (index == -1) {
                  const result = newPreSetting.pictures.push(
                    sharedPictureList.pictures[i]
                  );
                  index = result - 1;
                }
                newPreSetting.pictures[
                  index
                ].src = `data:${data.file_format};base64,${image_data}`;
                return newPreSetting;
              });
            }
          });
        }
      }
    } else {
      for (let i = 0; i < pictData.pictures.length; i++) {
        let index = sharedPictureList.pictures.findIndex(
          u => u.id === pictData.pictures[i].id
        );
        if (index == -1) {
          setPictData((preSetting: TSharedPictureList) => {
            preSetting.pictures.splice(i, 1);
            const newPreSetting: TSharedPictureList = _.cloneDeep(preSetting);
            return newPreSetting;
          });
        }
      }
    }
  };

  /**
   * 写真を選択リストに追加
   * @param picture
   */
  const addSelectedPictures = (picture: TSharedPicture) => {
    if (!selectedPictures.includes(picture)) {
      setSelectedPictures([...selectedPictures, picture]);
    }
  };

  /**
   * 全ての写真を選択リストに追加
   */
  const addAllSelectedPictures = () => {
    setSelectedPictures([]);
    setSelectedPictures(paginatedPictures);
  };

  /**
   * 写真を選択リストから削除
   * @param picture
   */
  const removeSelectedPictures = (picture: TSharedPicture) => {
    if (selectedPictures.includes(picture)) {
      const newSelectedFileIds = selectedPictures.filter(
        f => f.id !== picture.id
      );
      setSelectedPictures(newSelectedFileIds);
    }
  };

  /**
   * 全ての写真を選択リストから削除
   */
  const removeAllSelectedPictures = () => {
    setSelectedPictures([]);
    setAllChecked(false);
    setAllUploadedPicturesChecked(false);
  };

  /**
   * 全件チェック
   */
  const handleAllCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked: boolean = event.target.checked;
    if (paginatedPictures && paginatedPictures.length > 0) {
      if (checked) {
        addAllSelectedPictures();
      } else {
        removeAllSelectedPictures();
      }
      setAllChecked(checked);
      setAllUploadedPicturesChecked(false);
    }
  };

  /**
   * 現在のページに表示されている、共有先がアップロードした写真を全件選択リストに追加
   */
  const addAllUploadedPicturesOnCurrentPage = () => {
    const newSelectedPictures: TSharedPicture[] = [];
    paginatedPictures.forEach(picture => {
      if (
        sharedPictureList.share_picture_guest_id === picture.created_guest_id
      ) {
        newSelectedPictures.push(picture);
      }
    });
    setSelectedPictures(newSelectedPictures);
  };

  /**
   * 共有先がアップロードした写真を全件チェック
   */
  const onAllUploadedPicturesCheck = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const checked: boolean = event.target.checked;
    if (checked) {
      addAllUploadedPicturesOnCurrentPage();
    } else {
      removeAllSelectedPictures();
    }
    setAllUploadedPicturesChecked(checked);
    setAllChecked(false);
  };

  /**
   * zipダウンロード
   */
  const downloadPictureZip = async () => {
    if (selectedPictures.length <= 0) return;
    setProgressFlg(true);

    if (selectedPictures.length === 1) {
      await getPictureDownload(String(selectedPictures[0].id), true).then(
        (resData: any) => {
          checkResData(resData, enqueueSnackbar).then((data: any) => {
            // 写真ダウンロード
            let bin = atob(data.data.replace(/^.*,/, ''));

            let buffer = new Uint8Array(bin.length);
            for (let i = 0; i < bin.length; i++) {
              buffer[i] = bin.charCodeAt(i);
            }

            let fileData = new File([buffer.buffer], data.data, {
              type: data.file_format
            });

            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(fileData);
            const fileName = selectedPictures[0].file_name;
            downloadLink.download = fileName;
            downloadLink.click();
          });
        }
      );
    } else {
      const params: string = selectedPictures
        .map(picture => {
          return picture.id;
        })
        .join(',');

      await getPicturesZip(params).then((resData: any) => {
        checkResData(resData, enqueueSnackbar).then((data: any) => {
          // 写真ダウンロード
          let bin = atob(data.data.replace(/^.*,/, ''));

          let buffer = new Uint8Array(bin.length);
          for (let i = 0; i < bin.length; i++) {
            buffer[i] = bin.charCodeAt(i);
          }

          let fileData = new File([buffer.buffer], data.data, {
            type: data.file_format
          });

          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(fileData);
          const fileName = 'picture-list.zip';
          downloadLink.download = fileName;
          downloadLink.click();
        });
      });
    }
    setAllChecked(false);
    setAllUploadedPicturesChecked(false);
    setSelectedPictures([]);
    setProgressFlg(false);
  };

  /**
   * 選択写真削除
   */
  const onDeletePictures = () => {
    selectedPictures.forEach(picture => {
      deletePicture(picture.id).then(resData => {
        checkResData(resData, enqueueSnackbar).then(() => {
          getSharedPictureList();
        });
      });
    });
    removeAllSelectedPictures();
    setDeleteModalOpen(false);
  };

  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            backgroundColor: '#FFFFFF',
            borderTop: '1px solid #f5f5f5',
            borderBottom: '1px solid #f5f5f5',
            padding: '30px 20px'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 36
            }}
          >
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '20px'
                }}
              >
                <FolderOpenIcon style={{ marginRight: '8px' }} />
                <span style={{ fontWeight: 'bold' }}>
                  {sharedPictureList.folder_name}
                </span>
                <div style={{ paddingLeft: 5 }}>
                  <FormControl className={classes.formControl}>
                    <BasicSelect
                      className={'select-div'}
                      value={displayLimit}
                      onChange={e => {
                        setDisplayLimit(parseInt(e.target.value));
                        setCurrentPage(1);
                        setSelectedPictures([]);
                        setAllChecked(false);
                        setAllUploadedPicturesChecked(false);
                      }}
                      onClick={event => event.stopPropagation()}
                      inputProps={{ 'aria-label': 'age' }}
                      disableUnderline
                    >
                      <option value={30}>30件</option>
                      <option value={50}>50件</option>
                      <option value={100}>100件</option>
                    </BasicSelect>
                  </FormControl>
                </div>
                <div style={{ marginLeft: 36, fontSize: 14 }}>
                  <Checkbox
                    checked={allChecked}
                    onChange={handleAllCheck}
                    color='default'
                  />
                  ページ内全選択
                </div>

                {isUploadedPicture && (
                  <div style={{ marginLeft: 12, fontSize: 14 }}>
                    <Checkbox
                      checked={allUploadedPicturesChecked}
                      onChange={onAllUploadedPicturesCheck}
                      color='default'
                    />
                    追加した写真全選択
                  </div>
                )}
              </div>
              <div style={{ marginLeft: '12px', color: 'gray' }}>
                {sharedPictureList.construct_name}
              </div>
            </div>

            {/* フォルダ内ボタン */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'end',
                alignItems: 'center'
              }}
            >
              <div
                style={{
                  paddingRight: 10,
                  marginRight: 14,
                  borderRight: '1px solid #cfcfcf'
                }}
              >
                <div>登録数（{sharedPictureList.pictures.length}件）</div>
              </div>

              {selectedPictures.length !== 0 && (
                <div style={{ color: 'red', marginRight: 24 }}>
                  {selectedPictures.length}件選択中
                </div>
              )}
              <div style={{ marginRight: 14 }}>
                <div>選択した写真を</div>
              </div>
              <Button
                style={{
                  backgroundColor: buttonColor,
                  color: '#fff'
                }}
                variant='contained'
                color='secondary'
                onClick={downloadPictureZip}
                disabled={disableDownloadBtn}
              >
                <GetAppIcon />
                <span style={{ marginLeft: 4 }}>ダウンロード</span>
              </Button>
              {sharedPictureList.uploadable && (
                <>
                  <CustomTooltip
                    title={<p>追加した写真のみ削除可</p>}
                    placement='top'
                  >
                    <div style={{ marginLeft: 8 }}>
                      <Button
                        style={{
                          backgroundColor: buttonColor,
                          color: '#fff'
                        }}
                        variant='contained'
                        color='secondary'
                        onClick={() => setDeleteModalOpen(true)}
                        disabled={disableDeleteBtn}
                      >
                        <DeleteIcon />
                        <span style={{ marginLeft: 4 }}>削除</span>
                      </Button>
                    </div>
                  </CustomTooltip>

                  <div
                    style={{
                      marginLeft: 8,
                      paddingLeft: 8,
                      borderLeft: '1px solid #cfcfcf'
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: '#007dff',
                        marginRight: 10
                      }}
                      onClick={() => setAddModalOpen(true)}
                      variant='contained'
                      color='secondary'
                    >
                      <NoteAddIcon />
                      <span style={{ marginLeft: 4 }}>写真を追加</span>
                    </Button>
                  </div>
                </>
              )}
            </div>
          </div>

          {pictData.pictures.length === 0 ? (
            <div>フォルダに写真がありません</div>
          ) : (
            <>
              <Grid container spacing={4}>
                {paginatedPictures.map(
                  (picture: TSharedPicture, index: number) => (
                    <PictureList
                      key={picture.id}
                      picture={picture}
                      addSelectedPictures={() => addSelectedPictures(picture)}
                      removeSelectedPictures={() =>
                        removeSelectedPictures(picture)
                      }
                      selectedPictures={selectedPictures}
                      setSelectedPictures={setSelectedPictures}
                      getSharedPictureList={getSharedPictureList}
                      setDeleteModalOpen={setDeleteModalOpen}
                      isGuestPicture={
                        sharedPictureList.share_picture_guest_id ===
                        picture.created_guest_id
                      }
                    />
                  )
                )}
              </Grid>
              <Box className={classes.pagenationContainer}>
                <PaginationComponent
                  page={currentPage}
                  pageCount={pageCount}
                  setCurrentPage={(page: number) => {
                    setCurrentPage(page);
                    setSelectedPictures([]);
                    setAllChecked(false);
                    setAllUploadedPicturesChecked(false);
                  }}
                />
              </Box>
            </>
          )}
        </Grid>
      </Grid>

      {/* AddModalコンポーネントは、CONOCユーザー側のページのものとAPI以外は同じであるため、 */}
      {/* 開いているページによってAPIを変更することにより共通化し、pictureListPageディレクトリから呼び出して使用している */}
      <AddModal
        modalOpen={addModalopen}
        setModalOpen={setAddModalOpen}
        constructId={sharedPictureList.construct_id}
        pictureFolderId={sharedPictureList.folder_id}
        getFolderPictureList={getSharedPictureList}
      />

      <DeleteModal
        modalOpen={deleteModalOpen}
        setModalOpen={setDeleteModalOpen}
        selectedPictures={selectedPictures}
        onDeletePictures={onDeletePictures}
      />
    </>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      minWidth: 120,
      backgroundColor: '#FFFFFF',
      marginLeft: 10
    },
    pagenationContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 10,
      marginBottom: 30
    }
  })
);
